import { ENDPIONTS, httpService, Operation, PaginatedResult } from "@api";
import { useFetch } from "@hooks";
import { Branch, Department, Employee, SubBranch } from "@models";
import { Action, ComplexHeader, ExportData, Filterable, MyRingLoader, Table, TableVerticalConfigs } from "@shared";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { AddEmployee, UploadOthers } from "@components";
import { FiPlus, FiUpload } from "react-icons/fi";
import Pagination from "react-responsive-pagination";
import { FetchEmployeesVM } from "@viewModels";

const ListOthers = () => {
  const [queryStrings] = useSearchParams();
  const MySwal = withReactContent(Swal);
  const navigate = useNavigate();

  const [reload, setReload] = useState<boolean | undefined>(undefined);
  const [currentPage, setCurrentPage] = useState(1);

  queryStrings.set("category.eq", "Others");

  const fetchEmployees = useFetch<PaginatedResult<FetchEmployeesVM>>(
    {
      endPoint: ENDPIONTS.employees,
      queryStrings: queryStrings,
      reload: reload,
    },
    new PaginatedResult<FetchEmployeesVM>()
  );

  const fetchBranches = useFetch<PaginatedResult<Branch>>(
    {
      endPoint: ENDPIONTS.branches,
      reload: reload,
      ignorePagination: true,
    },
    new PaginatedResult<Branch>()
  );

  useEffect(() => {}, [fetchEmployees?.isFetching, fetchBranches?.isFetching]);

  const headers: ComplexHeader[] = [
    { key: "employeeId", title: "ID" },
    { key: "name", title: "Full Name" },
    { key: "typeOfContract", title: "Type Of Contract" },
    { key: "location", title: "Branch" },
    { key: "designationName", title: "Designation" },
  ];

  const filters: Filterable<FetchEmployeesVM>[] = [
    {
      key: "employeeId",
      title: "ID",
      format: "text",
      operation: Operation.like,
    },
    { key: "name", title: "name", format: "text", operation: Operation.like },
    {
      key: "branchId",
      title: "branch",
      format: "select",
      data: [
        ...fetchBranches?.data?.items?.map((d) => ({
          id: d.id,
          name: d.location,
        })),
      ],
    },
    {
      key: "contractStatus",
      title: "Status",
      format: "select",
      data: [
        { id: "true", name: "Active" },
        { id: "false", name: "Terminated" },
      ],
    },
  ];

  const actions: Action[] = [
    {
      key: "",
      actionType: "badge",
      click: (e: Employee) => {
        navigate(`/others/profile/${e.id}`);
      },
      title: "Profile",
      color: "primary",
    },
  ];

  const onAddOtherClickHandler = () => {
    MySwal.fire({
      showConfirmButton: false,
      allowOutsideClick: false,
      showCloseButton: true,
      width: 900,
      html: (
        <AddEmployee
          callback={() => setReload((prev) => (prev === undefined ? true : !prev))}
          defaultCategory="Others"
        />
      ),
    });
  };

  const onUploadClickHandler = () => {
    MySwal.fire({
      showConfirmButton: false,
      allowOutsideClick: false,
      showCloseButton: true,
      width: 700,
      html: <UploadOthers callback={() => setReload((prev) => (prev === undefined ? true : !prev))} />,
    });
  };

  const handlePageChange = (page: number, size: number) => {
    queryStrings.set("size", size.toString());
    queryStrings.set("page", (page - 1).toString());
    navigate({ search: `?${queryStrings.toString()}` });
  };

  return (
    <div className="content container-fluid">
      <div className="row align-items-center">
        <div className="col">
          <h3 className="page-title">Others</h3>
        </div>
        <div className="col-auto float-end ms-auto">
          <button className="btn btn-sm btn-warning rounded-circle m-1" onClick={onUploadClickHandler}>
            <FiUpload />
          </button>
          <button className="btn btn-sm btn-primary rounded-circle m-1" onClick={onAddOtherClickHandler}>
            <FiPlus />
          </button>
          <TableVerticalConfigs filters={filters} />
        </div>
      </div>
      <div className="row mt-3">
        <Table
          actions={actions}
          class="table table-striped table-hover mb-0"
          data={fetchEmployees?.data ?? []}
          headers={headers}
          isFetchingPage={fetchEmployees.isFetching}
          showCounter
          onPageChange={handlePageChange}
          paginationClass="row mt-3"
        />
      </div>
    </div>
  );
};

export default ListOthers;
